import { useNavigate } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { AuthContext } from "../contexts/AuthContext";
import axiosInstance from "../utils/axiosInstance";
import Input from "../components/Input";


const Register = () => {
  const url =
    "https://plus.unsplash.com/premium_photo-1661398463833-ea3c24584578?q=80&w=1471&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
  const url1 =
    "https://images.unsplash.com/photo-1576091358783-a212ec293ff3?q=80&w=1450&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

  const [currentImage, setCurrentImage] = useState(url);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [lastName, setLastName] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const notify = (msg) => toast(msg);
  const { setUserData } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);

const handleRegister = async (e) => {
  e.preventDefault();

  if (!email || !password || !name || !lastName || !address || !phoneNumber) {
    notify("Please fill in all fields");
    return;
  }

  try {
    setLoading(true); // Start loading
    const res = await axiosInstance.post("/auth/create-account/buyer", {
      firstName: name,
      lastName: lastName,
      phoneNumber,
      email,
      password,
      address,
    });

    if (res.data.status === "success") {
      notify("Sign Up Successful");
      setUserData(res.data.data);
      setTimeout(() => navigate("/auth/login/buyer"), 3000); // Delay navigation
    } else if (res.data.message === "Buyer already exists") {
      notify("User already exists. Please log in.");
      setTimeout(() => navigate("/auth/login/buyer"), 3000); // Delay navigation
    } else {
      notify("Something went wrong. Please try again.");
    }
  } catch (err) {
    if (err.response?.data?.message === "Buyer already exists") {
      notify("User already exists. Please log in.");
      setTimeout(() => navigate("/auth/login/buyer"), 3000); // Delay navigation
    } else {
      notify("Sign Up Failed. Please try again.");
    }
  } finally {
    setLoading(false); // End loading
  }
};

  // Switch images every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage === url ? url1 : url));
    }, 5000);
    return () => clearInterval(interval); // Clear interval on unmount
  }, []);

  return (
    <div className="flex flex-col md:flex-row h-auto overflow-y-auto md:h-screen">
      {/* Form Container */}
      <div className="relative flex-1 w-full md:w-1/4 bg-white p-8 text-black md:ml-8 mt-4 md:mt-0 rounded-t-none md:rounded-tl-full border-t-4 md:border-t-0 border-white shadow-lg space-y-4">
        <h1 className="text-5xl font-bold text-center md:hidden mb-4 text-green-600">
          υγεία
        </h1>
        <form className="space-y-2" onSubmit={handleRegister}>
          <Input
            type="text"
            label="First Name:"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="text-sm"
          />
          <Input
            type="text"
            label="Last Name:"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
            className="text-sm"
          />
          <Input
            type="text"
            label="Address:"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            required
            className="text-sm"
          />
          <Input
            type="text"
            label="Phone Number:"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            required
            className="text-sm"
          />
          <Input
            type="email"
            label="Email:"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="text-sm"
          />

          <div>
            <label htmlFor="password" className="block font-bold text-sm">
              Password:
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-2 text-black border border-gray-300 rounded-md "
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500"
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="bg-green-600 text-white font-bold py-2 px-4 rounded-md w-full mt-4"
            disabled={loading}
          >
            {loading ? "Signing Up..." : "Sign Up"}
          </button>
          <h4 className="mt-4">
            Already have an account?
            <span
              onClick={() => navigate("/auth/login/buyer")}
              className="text-blue-400 hover:underline cursor-pointer ml-2 "
            >
              Login
            </span>
          </h4>
        </form>
        <ToastContainer />
      </div>

      {/* Image Container */}
      <div
        className="relative flex-1 w-full h-full hidden md:flex justify-center items-center"
        style={{
          backgroundImage: `url(${currentImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 flex justify-center items-center">
          <span className="text-white text-8xl font-bold drop-shadow-lg">
            υγεία
          </span>
        </div>
      </div>
    </div>
  );
};

export default Register;
